export type Override = {
  label: string;
  value: string;
  overrideArmor?: number;
  overrideSpecie?: number;
  houndDescriptionPrepend?: string;
  limitToMaterialName?: string;
  overrideColor?: number;
  overrideColorMaterial?: string;
};

export const overrideInventory: Array<Override> = [
  {
    label: 'Unstoppable Domains',
    value: 'UD1',
    overrideArmor: 8,
    houndDescriptionPrepend: 'Houndrace x Unstoppable Domains Rare Partnership Hound',
    overrideSpecie: 101,
    limitToMaterialName: 'Metal',
    overrideColor: 0x00BCFF,
    overrideColorMaterial: 'Light Metal'
  },
  {
    label: 'Unstoppable Domains Secondary',
    value: 'UD2',
    overrideArmor: 8,
    houndDescriptionPrepend: 'Houndrace x Unstoppable Domains Rare Partnership Hound',
    overrideSpecie: 101,
    limitToMaterialName: 'Metal',
    overrideColor: 0x00BCFF,
    overrideColorMaterial: 'Light Metal'
  },
  {
    label: 'X-Mas',
    value: 'XMAS',
    overrideArmor: 5,
    limitToMaterialName: 'Metal'
  }
];
